import React from 'react';
import ITService from '../images/it.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Custom Software Development',
    description: 'Develop tailored software solutions to meet your unique needs. Our services include design, development, and deployment of custom applications.',
  },
  {
    icon: <FaLock />,
    title: 'Application Design & Development',
    description: 'Create user-friendly applications with our design and development services. We focus on functionality and aesthetics to deliver high-quality solutions.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'API Development & Integration',
    description: 'Enhance your systems with API development and integration. We create and integrate APIs to improve interoperability and streamline operations.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Front-End & Back-End Development',
    description: 'Build dynamic websites with our front-end and back-end development services. We ensure a seamless user experience and robust functionality.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'UI/UX Solutions',
    description: 'Improve user engagement with expert. We design intuitive interfaces and experiences that enhance usability and satisfaction.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'CRM Application Development',
    description: 'Streamline customer management with custom CRM applications. Our solutions help you track interactions, manage leads, and improve customer relationships.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Cloud Solutions',
    description: 'Leverage the cloud with our comprehensive solutions. We offer cloud storage, computing, and management services to optimize your IT infrastructure.',
  },
];

const SoftwareDevelopment = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={ITService}
        alt="IT Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Software Development & Custom Solutions</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert IT Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored IT Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic IT planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
      </div>
      </section>

    </div>

    </div>
  )
}

export default SoftwareDevelopment
